module.exports = __webpack_public_path__ + "img/moxing.asm.422f5756.jpg";